import { EEntityType } from '@/editor/types';

export function getArrowRulerConfig(
  startEntity: { type: EEntityType; id: string } | null,
  endEntity: { type: EEntityType; id: string } | null
) {
  const result = {
    arrow: false,
    reverse: false
  };

  if (startEntity && endEntity && startEntity.id !== endEntity.id) {
    const furnitureTypes = [EEntityType.Assembly, EEntityType.Furniture];
    const startIsFurniture = furnitureTypes.includes(startEntity.type);
    const endIsFurniture = furnitureTypes.includes(endEntity.type);

    result.arrow = startIsFurniture || endIsFurniture;
    result.reverse = !startIsFurniture && endIsFurniture;
  }

  return result;
}
